import API from "@/api";

const state = {
  using: [],
  owned: []
};

export const mutations = {
  SET_USING(state, payload) {
    state.using = payload;
  },

  SET_OWNED(state, payload) {
    state.owned = payload;
  }
};

export const actions = {
  async using({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.licensesUsing();
    commit("SET_USING", results.list);

    commit("REQUEST_DECREMENT", null, { root: true });
  },

  async owned({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.licensesOwned();
    commit("SET_OWNED", results.list);

    commit("REQUEST_DECREMENT", null, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
